import './namechip.scss';
import React from 'react';
import classnames from 'classnames';
import PropType from 'prop-types'
import ReactDOM from "react-dom";
import {UncontrolledTooltip} from "reactstrap";
import colors from "../../modules/theme/colors";
import { PropTypes } from 'mobx-react';

const colorClasses = [
  "bg-primary",
  "bg-secondary",
  "bg-warning",
  "bg-info"
];

/**
 * Renders a generated colored circle based on the user's name. Can also optionally display
 * the full name to the side or in a tooltip
 */
export class NameChip extends React.Component {
  static propTypes = {
    name: PropType.string,
    colorFrom: PropType.string, // optional id or some other unique string to this to hash a color not based off of the name
    className: PropType.string,
    size: PropType.oneOf(['xl', 'lg', 'md', 'sm', 'xs']),
    defaultName: PropType.any,
    overrideFullName: PropType.any,
    displayName: PropType.bool,
    tooltip: PropType.bool,
    overrideBgColor: PropTypes.string,
    overrideTextColor: PropTypes.string
  };


  setNameChipElement = (component) => {
    this.nameChip = ReactDOM.findDOMNode(component)
  };

  getNameChipElement = () => this.nameChip;

  render() {
    const {name, className, size, defaultName, displayName, colorFrom, tooltip, overrideFullName, overrideBgColor, overrideTextColor, ...props} = this.props;
    const classes = ["round-circle", "name-chip", "control-spacer-right"];
    const themeColors = colors({nColors: colorClasses.length});
    let abbreviation;
    let themeColor = themeColors[0];
    let isUnassigned = false;
    let themeColorNumber = 1;
    if ((colorFrom || name) && overrideBgColor === undefined) {
      let upper = (colorFrom || name).toUpperCase();
      let charSumHash = Array.from(upper.toLowerCase()).map(x => x.charCodeAt(0)).reduce((a, b) => a + b, 0);
      const colorIndex = charSumHash % colorClasses.length;
      const nameSplit = (name || '').toUpperCase().split(' ');
      abbreviation = nameSplit.length >= 2 ? `${nameSplit[0][0]}${nameSplit[nameSplit.length - 1][0]}` : nameSplit[0][0];
      themeColor = themeColors[colorIndex];
      themeColorNumber = colorIndex + 1;
    } else if (overrideBgColor !== undefined) {
      const nameSplit = (name || '').toUpperCase().split(' ');
      abbreviation = nameSplit.length >= 2 ? `${nameSplit[0][0]}${nameSplit[nameSplit.length - 1][0]}` : nameSplit[0][0];
      themeColor = overrideBgColor;
    } else {
      abbreviation = "";
      isUnassigned = true;
    }

    
    const circle = (
      <span ref={this.setNameChipElement}
            className={classnames(classes, className, size)}
            style={{backgroundColor: isUnassigned ? "var(--gray-500)" : themeColor, color: overrideTextColor !== undefined ? overrideTextColor : isUnassigned ? "var(--text-on-null)" : `var(--text-on-color-${themeColorNumber})`}}
            {...props}
      >
        <div>{abbreviation}</div>
      </span>
    );
    // TODO - adjust font size based on size
    const middleAlignedName = displayName && <span>{name || defaultName}</span>;

    return (
      tooltip
        ? <React.Fragment>
            <span className="nowrap d-flex align-items-center" ref={this.setNameChipElement}>{circle}{overrideFullName || middleAlignedName}</span>
            <UncontrolledTooltip
              container="inline"
              target={this.getNameChipElement}>
              { name || defaultName}
            </UncontrolledTooltip>
          </React.Fragment>
        : <span className="nowrap d-flex align-items-center">
            {circle}
            <span className="">{overrideFullName || middleAlignedName}</span>
          </span>

    );
  }




}




